// extracted by mini-css-extract-plugin
export default {"topicContainer":"styles_topicContainer__aixgN","btn":"styles_btn__ThYx5","btnActive":"styles_btnActive__Yh3SW"};